export type StudentSsnValidationResult = 'valid' | 'invalid-format' | 'invalid-pattern';

export function validateStudentSsn(value: string, pattern?: string | null): StudentSsnValidationResult {
	const trimmedValue = value.trim();
	if (!trimmedValue || !pattern?.trim()) {
		return 'valid';
	}

	const trimmedPattern = pattern.trim();
	// Match complete registration's CustomFieldRegex: decode stored doubled
	// backslashes first, falling back to the original if compilation fails.
	const candidates = [trimmedPattern.replace(/\\\\/g, '\\'), trimmedPattern];
	for (const candidate of candidates) {
		try {
			return new RegExp(candidate).test(trimmedValue) ? 'valid' : 'invalid-format';
		} catch {
			// Try the original pattern if the normalized one is not valid syntax.
		}
	}
	return 'invalid-pattern';
}
